"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing User operations. */
var UserImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class User class.
   * @param client Reference to the service client
   */
  function UserImpl(client) {
    (0, _classCallCheck2["default"])(this, UserImpl);
    this.client = client;
  }
  /**
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(UserImpl, [{
    key: "getUserContext",
    value: function getUserContext(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getUserContextOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getUsers",
    value: function getUsers(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getUsersOperationSpec);
    }
  }]);
  return UserImpl;
}(); // Operation Specifications


exports.UserImpl = UserImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getUserContextOperationSpec = {
  path: "/api/Portals({portalId})/user",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.UserViewModel
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getUsersOperationSpec = {
  path: "/api/Portals({portalId})/users",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "UserViewModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.q, Parameters.take],
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};